module.exports = __webpack_public_path__ + "img/23_21.9a7b74a8.png";